import React from 'react';
import Grid from '@mui/material/Unstable_Grid2';
import { FormControl, FormControlLabel, Radio, RadioGroup, TextField } from '@mui/material';

import './../styles/car-modified-selector.css'

function CarModifiedSelector({ hasModification, setHasModification, modificationText, setModificationText }) {
  const handleRadioChange = (e) => {
    setHasModification(e.target.value);
  }
  const handleModificationTextChange = (e) => {
    setModificationText(e.target.value);
  }

  return (
    <section className="car-modified-selector-container">
      <Grid container className="car-modified-toggle-container">
        <Grid item xs={12} className="car-modified-selector-grid-item">
          <FormControl>
            <RadioGroup
              aria-labelledby="car-modified-radio-buttons-group"
              name="car-modified-radio-buttons-group"
              value={hasModification}
              onChange={handleRadioChange}
            >
              <FormControlLabel
                value="YES"
                control={<Radio />}
                label="YES, MY CAR HAS BEEN MODIFIED"
                className="car-modified-radio-buttons-label"
              />
              <FormControlLabel
                value="NO"
                control={<Radio />}
                label="NO, MY CAR ONLY HAS FACTORY ACCESSORIES"
                className="car-modified-radio-buttons-label"
              />
            </RadioGroup>
          </FormControl>
        </Grid>
        {hasModification === 'YES' && (
          <Grid item xs={12} className="car-modified-selector-grid-item">
            <TextField
              className="car-modified-text-field"
              id="car-modified-text"
              label="Enter Text"
              multiline
              fullWidth
              rows={2}
              value={modificationText}
              onChange={handleModificationTextChange}
            />
          </Grid>
        )}
      </Grid>
    </section>
  )
}

export default CarModifiedSelector
